<template>
    <div>
        <div>
            <div>
                If the substance is in a component, specify all components where this concern element is included by doing it in
            </div>
            <div class="pb-1 demo-inline-spacing text-center">
                <b-form-radio
                    v-for="choice in orderChoices"
                    :name="radioName"
                    :value="choice"
                    v-model="order"
                    @input="onOrderChange"
                >
                    {{ $t('Component(ConcernElementPlacementHierarchyOrderEnum):' + choice) }}
                </b-form-radio>
            </div>
        </div>
        <ul class="list-unstyled">
            <li :style="calculateItemStyle(index)" v-for="(item, index) in hierarchy">
                <feather-icon
                    v-if="index > 0"
                    icon="ChevronRightIcon"
                /> {{item.title}}
            </li>
            <li @click="addComponent" :style="calculateItemStyle(hierarchy.length)" v-if="showAddButton">
                Add component
            </li>
        </ul>
        <b-breadcrumb class="pl-0">
            <b-breadcrumb-item :active="true" v-for="item in hierarchy">
                <strong>{{ item.title }}</strong>
            </b-breadcrumb-item>
            <b-breadcrumb-item @click="addComponent" v-if="showAddButton">
                Add component
            </b-breadcrumb-item>
        </b-breadcrumb>
    </div>
</template>

<script>
import {ConcernElementPlacementOrder} from "@core/domain/product";
import { BRow, BCol, BFormRadio, BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue';

export default {
    components: {
        BRow, BCol, BFormRadio, BBreadcrumb, BBreadcrumbItem,
    },
    props: {
        substance: {
            required: true,
            type: Object
        },
        placementHierarchy: {
            type: Object,
            default() {
                return {
                    order: ConcernElementPlacementOrder.TOP_DOWN,
                    hierarchy: []
                };
            }
        },
        showAddButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            order: this.placementHierarchy.order,
            orderChoices: ConcernElementPlacementOrder.toArray(),
            hierarchy: this.cloneHierarchy()
        };
    },
    methods: {
        addComponent() {
            this.$emit('addComponent');
        },
        onOrderChange() {
            if (this.order === ConcernElementPlacementOrder.TOP_DOWN) {
                if (this.placementHierarchy.order === ConcernElementPlacementOrder.TOP_DOWN) {
                    this.hierarchy = this.cloneHierarchy();
                } else {
                    this.hierarchy = this.cloneHierarchy().reverse();
                }
            } else {
                if (this.placementHierarchy.order === ConcernElementPlacementOrder.BOTTOM_TOP) {
                    this.hierarchy = this.cloneHierarchy()
                } else {
                    this.hierarchy = this.cloneHierarchy().reverse();
                }
            }
        },
        cloneHierarchy() {
            return this.placementHierarchy.hierarchy.map(i => i);
        },
        calculateItemStyle(index) {
            let k = 12;
            return 'padding-left: ' + (k * index) + 'px;';
        }
    },
    computed: {
        radioName() {
            return 'order_' + this.substance.id + '_' + this.placementHierarchy.hierarchy.map(item => item.title.length).join('_');
        },
    },
    watch: {
        placementHierarchy() {
            this.order = this.placementHierarchy.order;
            this.hierarchy = this.cloneHierarchy();
        }
    }
}
</script>
